var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"shadow-sm",attrs:{"toggleable":"lg","type":"dark","variant":"info","fixed":"top"}},[_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t('SYSTEM.SITENAME')))]),_vm._v(" "),_c('b-nav',{staticClass:"ml-auto"},[_c('UserMenu')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fdf4ec6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/NavigationBar.vue
// module id = null
// module chunks = 